import Link from 'next/link';
import styled from 'styled-components';

import * as COLORS from '~/colors';
import { type CorpFurusatoRecruitmentDataT } from '~/data/CorpFurusatoRecruitmentData';

type Props = {
  recruitment: CorpFurusatoRecruitmentDataT;
  withStatus: boolean;
};

export default function ComponentRecruitment({ recruitment, withStatus = false }: Props) {
  return (
    <Wrapper href={`/corp-furusato/recruitments/${recruitment.id}`}>
      {withStatus && <Status>{'企業\n募集中'}</Status>}
      <Cover src={recruitment.cover} />
      <Labels>
        <Label>企業版ふるさと納税</Label>
        <Corporate>広島県</Corporate>
      </Labels>
      <Title>{recruitment.title}</Title>
      <Tags>
        {['広島県'].map((t, i) => (
          <Tag key={i}>#{t}</Tag>
        ))}
        {[11, 15, 17].map((s) => (
          <Tag color={COLORS.sdgs[s]?.end} key={s}>
            #SDGs{s}
          </Tag>
        ))}
      </Tags>
    </Wrapper>
  );
}

const Wrapper = styled(Link)`
  display: block;
  width: 320px;
  height: 364px;
  background: #fff;
  position: relative;
  border-radius: 0 12px 12px 12px;
`;

const Cover = styled.img`
  width: 100%;
  height: 160px;
  object-fit: cover;
  border-radius: inherit;
`;

const Labels = styled.div`
  margin-top: -1px;
  display: flex;
  flex-direciton: row;
  align-items: center;
`;

const Label = styled.div`
  height: 30px;
  width: 150px;
  background: #ff346b;
  font-size: 12px;
  color: #fff;
  font-weight: bold;
  line-height: 30px;
  text-align: center;
  letter-spacing: 1px;
`;

const Corporate = styled.div`
  margin-left: 10px;
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 1px;
`;

const Title = styled.div`
  margin: 15px 35px;
  height: 90px;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 19px;
  font-weight: bold;
  line-height: 30px;
  letter-spacing: 1px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
`;

const Tags = styled.div`
  margin: 10px 35px 0 25px;
  border-top: 1px solid #b2b2b2;
  display: flex;
  flex-wrap: wrap;
`;

const Tag = styled.div`
  margin-top: 5px;
  margin-left: 10px;
  color: #747474;
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 1px;
  color: ${(props) => props.color};
`;

const Status = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 85px;
  height: 85px;
  text-align: center;
  line-height: 20px;
  font-size: 14px;
  font-weight: bold;
  background: #000;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  white-space: pre;
`;
